@if (holdMessages().length > 0) {
  <section class="w-full border-y bg-[#FFFFFF] relative overflow-hidden">
    <div
      class="flex flex-col gap-0 px-4 pt-4 border-l-[5px] border-[#FDB71A] relative"
      [class.pb-1]="holdMessages().length > 1"
      [class.pb-4]="!(holdMessages().length > 1)"
    >
      <div
        class="flex flex-col sm:flex-row sm:items-center gap-3 sm:min-h-[72px]"
        [ngClass]="anyHoldsHaveButton() ? 'min-h-[145px]' : 'min-h-[125px]'"
      >
        @if (currentMessage().showButton) {
          <div class="flex items-center gap-2 text-left flex-1">
            <wu-icon name="holdIcon" class="flex-shrink-0 cursor-pointer" />

            <div>
              <h3
                class="text-[#00334C] text-base font-bold leading-5 font-mulish"
              >
                {{ currentMessage().title }}
              </h3>
              <p class="text-[#464646] text-sm mt-1 text-[14px] font-mulish">
                {{ currentMessage().description
                }}{{ currentMessage().resolution }}
              </p>
            </div>
          </div>
        } @else {
          <button
            type="button"
            class="flex items-center gap-2 text-left flex-1"
            (click)="openMessage()"
          >
            <wu-icon name="holdIcon" class="flex-shrink-0 cursor-pointer" />
            <div>
              <h3
                class="text-[#00334C] text-base font-bold leading-5 font-mulish"
              >
                {{ currentMessage().title }}
              </h3>
              <p class="text-[#464646] text-sm mt-1 text-[14px] font-mulish">
                {{ currentMessage().description
                }}{{ currentMessage().resolution }}
              </p>
            </div>
          </button>
        }

        @if (currentMessage().showButton) {
          <div
            class="flex justify-center sm:justify-start sm:shrink-0 sm:self-center text-[14px]"
          >
            <button
              type="button"
              (click)="openMessage()"
              class="px-4 py-2 border border-[#00334C] text-walden-500 rounded-full shadow-sm text-sm font-bold font-mulish"
            >
              {{ currentMessage().buttonName }}
            </button>
          </div>
        }
      </div>

      @if (holdMessages().length > 1) {
        <div class="flex items-center justify-center gap-2 mt-3 w-full">
          @for (message of holdMessages(); track $index) {
            <button
              type="button"
              class="h-3 w-3 rounded-full border border-[#1f2937] flex items-center justify-center"
              [class.bg-[#1f2937]]="currentIndex() === $index"
              [class.bg-transparent]="currentIndex() !== $index"
              (click)="goToSlide($index)"
              [attr.aria-label]="'Go to message ' + ($index + 1)"
            ></button>
          }
        </div>
      }
    </div>
  </section>
}
